import React, { ReactNode } from 'react'

import { Provider } from 'react-redux'
import { store } from 'shared/config/store'
import { userApi } from 'shared/api/userApi'
interface AppProps {
  children: ReactNode;
}

console.log(`App version: ${userApi.getAppVersion()}`)

function App({ children }: AppProps) {
  return (

    <Provider store={store}>
      {children}
    </Provider>
  )
}

export default App
